import React from 'react';
import { Modal } from '../shared/ui';
import PackageEnquiryForm from './PackageEnquiryForm';

const EnquiryModal = ({ open, onClose, pkg, labels = {}, source = 'LISTING', initialValues = {} }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={labels.enquire || 'Enquire'}
      className="max-h-[90vh] overflow-hidden"
      bodyClassName="max-h-[70vh] overflow-y-auto pr-1"
    >
      <PackageEnquiryForm
        pkg={pkg}
        source={source}
        initialValues={initialValues}
        onSuccess={onClose}
        onCancel={onClose}
        labels={labels}
      />
    </Modal>
  );
};

export default EnquiryModal;
